import makeStyles from "@mui/styles/makeStyles";

export const useTooltipStyles = makeStyles(() => ({
  tooltip: () => ({
    backgroundColor: "transparent",
    margin: 0,
    padding: 0,
  }),
}));
